/* eslint-disable @typescript-eslint/no-explicit-any */
import { authActions } from "@/redux/features/auth-slice";
// import { TRefreshAuthTokenResDto } from "@/types/dtos/auth";
import { useDispatch } from "react-redux";
import axiosPrivate from "./axios";

export function useRefreshToken() {
  const dispatch = useDispatch();

  const refresh = async (): Promise<string | null> => {
    try {
      const refreshToken = localStorage.getItem("refreshToken");
      const redirectPath = localStorage.getItem("redirectPath");
      // const utm = searchParam.get("utm");
      // const referrer = searchParam.get("referrer");

      if (!refreshToken) {
        handleLogout(redirectPath);
        return null;
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response = await axiosPrivate.post<any>(
        "/twitter/refresh",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${refreshToken}`,
          },
        },
      );

      const accessToken = response.data?.accessToken;
      const newRefreshToken = response.data?.refreshToken;

      if (accessToken) {
        dispatch(authActions.setAccessToken(accessToken));
        localStorage.setItem("accessToken", accessToken);
        if (newRefreshToken) {
          localStorage.setItem("refreshToken", newRefreshToken);
        }
        return accessToken;
      }

      return null;
    } catch (err: any) {
      const status = err?.response?.status;
      if (status === 401 || status === 400) {
        const redirectPath = localStorage.getItem("redirectPath");
        handleLogout(redirectPath);
        return null;
      }

      throw err; // Don't swallow other errors
    }
  };

  const handleLogout = (
    redirectPath: string | null,
    utm?: string | null,
    referrer?: string | null,
  ) => {
    // const redirectWithQuery = useRedirectWithQuery();
    const encryptedCodeMaps = localStorage.getItem("encryptedCodesMap");
    localStorage.clear();
    sessionStorage.clear();

    if (redirectPath) {
      localStorage.setItem("redirectPath", redirectPath);
    }
    if (utm) {
      localStorage.setItem("utm", utm);
    }
    if (referrer) {
      localStorage.setItem("referrer", referrer);
    }
    if (encryptedCodeMaps) {
      localStorage.setItem("encryptedCodesMap", encryptedCodeMaps);
    }

    // redirectWithQuery("/");
  };

  return refresh;
}
